module.exports = __webpack_public_path__ + "static/media/cover2.756ff14d.jpg";